import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { motion } from "framer-motion";

function DonateForm() {

const [loading, setLoading] = useState(false);

const [formData, setFormData] = useState({
name: "",
email: "",
phone: "",
address: "",
amount: "",
cause: "",
message: ""
});

const handleChange = (e) => {
setFormData({
...formData,
[e.target.name]: e.target.value
});
};

const handleSubmit = async (e) => {
e.preventDefault();


setLoading(true);

try {

  const res = await axios.post(
    "https://ekya-backend.onrender.com/api/donate/create",
    formData
  );

  Swal.fire({
    icon: "success",
    title: "Thank You ❤️",
    text: "Your donation request has been submitted successfully.",
    confirmButtonColor: "#2F5D50"
  });

  setFormData({
    name: "",
    email: "",
    phone: "",
    address: "",
    amount: "",
    cause: "",
    message: ""
  });

} catch (err) {

  Swal.fire({
    icon: "error",
    title: "Submission Failed",
    text:
      err?.response?.data?.message ||
      err.message ||
      "Something went wrong"
  });

  console.log(err);

} finally {
  setLoading(false);
}


};

return ( <div className="min-h-screen bg-[#F8F5F0] py-20 px-6">


  <motion.div
    initial={{ opacity: 0, y: 60 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    className="
      max-w-3xl
      mx-auto
      bg-white
      p-10
      rounded-3xl
      shadow-2xl
    "
  >

    <motion.h1
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="
        text-4xl
        md:text-5xl
        font-bold
        text-center
        text-[#2F5D50]
        mb-4
      "
    >
      Donate To EKYA ❤️
    </motion.h1>

    <p className="text-center text-gray-600 mb-10">
      Every contribution helps us create meaningful impact.
    </p>

    <form
      onSubmit={handleSubmit}
      className="space-y-5"
    >

      <input
        type="text"
        name="name"
        placeholder="Full Name"
        value={formData.name}
        onChange={handleChange}
        required
        className="
          w-full
          border
          p-4
          rounded-xl
          focus:outline-none
          focus:ring-2
          focus:ring-[#2F5D50]
        "
      />

      <input
        type="email"
        name="email"
        placeholder="Email Address"
        value={formData.email}
        onChange={handleChange}
        required
        className="
          w-full
          border
          p-4
          rounded-xl
          focus:outline-none
          focus:ring-2
          focus:ring-[#2F5D50]
        "
      />

      <input
        type="tel"
        name="phone"
        placeholder="Phone Number"
        value={formData.phone}
        onChange={handleChange}
        required
        className="
          w-full
          border
          p-4
          rounded-xl
          focus:outline-none
          focus:ring-2
          focus:ring-[#2F5D50]
        "
      />

      <textarea
        name="address"
        placeholder="Full Address"
        value={formData.address}
        onChange={handleChange}
        rows="3"
        required
        className="
          w-full
          border
          p-4
          rounded-xl
          focus:outline-none
          focus:ring-2
          focus:ring-[#2F5D50]
        "
      />

      <input
        type="number"
        name="amount"
        placeholder="Donation Amount"
        value={formData.amount}
        onChange={handleChange}
        required
        className="
          w-full
          border
          p-4
          rounded-xl
          focus:outline-none
          focus:ring-2
          focus:ring-[#2F5D50]
        "
      />

      <select
        name="cause"
        value={formData.cause}
        onChange={handleChange}
        required
        className="
          w-full
          border
          p-4
          rounded-xl
          focus:outline-none
          focus:ring-2
          focus:ring-[#2F5D50]
        "
      >
        <option value="">
          Select Donation Cause
        </option>

        <option value="Animal Welfare">
          Animal Welfare
        </option>

        <option value="Education Support">
          Education Support
        </option>

        <option value="Community Projects">
          Community Projects
        </option>

        <option value="Environmental Action">
          Environmental Action
        </option>
      </select>

      <textarea
        name="message"
        placeholder="Message (Optional)"
        value={formData.message}
        onChange={handleChange}
        rows="4"
        className="
          w-full
          border
          p-4
          rounded-xl
          focus:outline-none
          focus:ring-2
          focus:ring-[#2F5D50]
        "
      />

      <motion.button
        whileHover={{
          scale: 1.03
        }}
        whileTap={{
          scale: 0.95
        }}
        disabled={loading}
        type="submit"
        className="
          w-full
          bg-[#4B1D3F]
          text-white
          py-4
          rounded-xl
          font-semibold
          shadow-lg
        "
      >
        {loading
          ? "Submitting..."
          : "Submit Donation ❤️"}
      </motion.button>

    </form>

  </motion.div>

</div>


);
}

export default DonateForm;
